import { ReactNode } from 'react'

export interface HeaderProps {
  columns: ReactNode[]
}

const Header = ({ columns }: HeaderProps) => (
  <thead>
    <tr>
      {columns.map((column, index) => (
        <th key={index}>{column}</th>
      ))}
    </tr>
  </thead>
)

export default Header
